"use client"

import { Dialog, Button, Text, useDisclosure } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import CookieService from "../../../App/CookieService";

function LocationModal(props: { open: boolean }) {
    const { open, onOpen, onClose } = useDisclosure()
    const navigate = useNavigate()

    useEffect(() => {
        const checkCookie = async () => {
            const cookieExists = await CookieService.hasCookie('locationReminderDisplayed');
            if (props.open && !cookieExists) {
                onOpen();
                await CookieService.setCookie('locationReminderDisplayed', 'true', { 
                    path: '/', 
                    maxAge: 31536000 // 1 year
                });
            } else if (!props.open) {
                onClose();
            }
        };
        checkCookie();
    }, [onClose, onOpen, props.open]);

    return (
        <Dialog.Root placement={"center"} size={"lg"} open={open}>
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content style={{ padding: "1.75rem", borderRadius: "14px" }}>
                    <Dialog.Header fontFamily={"Inter"} style={{ padding: "0.25rem 0 0.75rem 0" }}>
                        <Text as="h2" fontSize="2xl" fontWeight="500" color="#1c3e42" lineHeight="1.35">
                            Um auf lokaler Ebene noch besser vernetzen zu können
                        </Text>
                    </Dialog.Header>
                    <Dialog.Body fontFamily={"Inter"} style={{ padding: "0.75rem 0 0.5rem 0" }}>
                        <Text color="#1c3e42" lineHeight="1.7" fontSize="md">
                            erfassen wir die Postleitzahlen von den Arbeitsorten unserer Mitglieder. Bitte ergänze in den
                            Einstellungen deine Postleitzahl.
                        </Text>
                    </Dialog.Body>
                    <Dialog.Footer style={{ marginTop: "1.5rem", padding: "0.5rem 0 0 0" }}>
                        <Dialog.ActionTrigger asChild>
                            <Button
                                padding="1rem 1.25rem"
                                backgroundColor="#e09f53"
                                color="#fff"
                                onClick={() => {
                                    onClose()
                                    navigate('/user-profile?settings=profile')
                                }}
                            >
                                Jetzt anpassen
                            </Button>
                        </Dialog.ActionTrigger>
                    </Dialog.Footer>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    )
}

export default LocationModal